import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { LinkForm } from '@/features/link-form';
import { LinkListPage } from '@/features/link-list';
import { useSecretTokenStore } from '@/stores/secretToken';

type Page = 'create' | 'list';

export function App(): React.ReactElement {
  const [currentPage, setCurrentPage] = useState<Page>('create');
  const { secretToken } = useSecretTokenStore();

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-bold">LinkPls</h1>
            {secretToken && (
              <nav className="flex gap-2">
                <Button
                  variant={currentPage === 'create' ? 'default' : 'ghost'}
                  size="sm"
                  onClick={(): void => {
                    setCurrentPage('create');
                  }}
                >
                  リンク作成
                </Button>
                <Button
                  variant={currentPage === 'list' ? 'default' : 'ghost'}
                  size="sm"
                  onClick={(): void => {
                    setCurrentPage('list');
                  }}
                >
                  リンク一覧
                </Button>
              </nav>
            )}
          </div>
        </div>
      </header>
      <main className="container mx-auto max-w-xl px-4 py-8">
        <div className="mb-8 text-center">
          <h2 className="text-xl font-semibold">
            短縮URL + クリック計測サービス
          </h2>
          <p className="mt-2 text-muted-foreground">
            長いURLを短縮して、クリック数を計測できます
          </p>
        </div>
        {currentPage === 'create' ? <LinkForm /> : <LinkListPage />}
      </main>
    </div>
  );
}
